// extracted by css-extract-rspack-plugin
export default {"bar":"_4c951733","barContent":"_6a63319a"};